// extracted by mini-css-extract-plugin
export default {"containerStyle":"styles_containerStyle__gDc3s","textStyle":"styles_textStyle__GDNvb","linkStyle":"styles_linkStyle__yssIN"};